'use client';

import React, { useEffect, useState } from 'react';
import {
  useUserState,
  useUserDispatch,
} from '@/components/context/UserContext';
import { useTranslation } from 'react-i18next';
import useFetch from 'use-http';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogBody,
} from '@/components/ui/dialog';
import { Heading } from '@/components/ui/shared/heading';
import { Label } from '@/components/ui/label';
import moment from 'moment';
import { MaterialIcon } from '@/components/ui/shared/materialIcon';

export default function AccountDeletion() {
  const { t } = useTranslation();
  const userState = useUserState();
  const sessionDispatch = useUserDispatch();
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    post: deleteUserAccountRequest,
    response: deleteUserAccountResponse,
  } = useFetch(`/UserAccount/Delete`);

  const handleUserAccountDeleteConfirm = async () => {
    setLoading(true);
    const response = await deleteUserAccountRequest('', {
      id: userState.id,
    });

    if (deleteUserAccountResponse.ok) {
      sessionDispatch({
        type: 'UPDATE',
        data: {
          scheduledToDeleteDate: response,
        },
      });
    }

    setShowDeleteConfirm(false);
    setLoading(false);
  };

  return (
    <Card>
      <CardHeader className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-0">
        <div className="flex flex-col gap-y-2">
          <Heading variant={'userAccountTitle'}>
            {userState?.scheduledToDeleteDate
              ? 'Paskyra bus panaikinta: ' +
                moment(userState?.scheduledToDeleteDate).format('YYYY-MM-DD')
              : t('userAccount.userInfoTab.accountTitle', {
                  defaultValue: 'Paskyros ištrynimas',
                })}
          </Heading>
        </div>
        <Button
          variant={'destro'}
          onClick={() => {
            if (userState?.scheduledToDeleteDate) {
              handleUserAccountDeleteConfirm();
            } else setShowDeleteConfirm(true);
          }}
        >
          <MaterialIcon icon="close" />
          {userState?.scheduledToDeleteDate
            ? 'Atšaukti'
            : t('userAccount.userInfoTab.deleteAccount', {
                defaultValue: 'Ištrinti paskyrą',
              })}
        </Button>
      </CardHeader>

      <Dialog open={showDeleteConfirm} onOpenChange={setShowDeleteConfirm}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Paskyros panaikinimas</DialogTitle>
          </DialogHeader>
          <DialogBody>
            {t('userAccount.userInfoTab.deleteConfirm.confirm', {
              time: process.env.REACT_APP_USER_ACCOUNT_DELETE_TIME,
              defaultValue: 'Ar tikrai norite ištrinti savo paskyrą?',
            })}
          </DialogBody>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => setShowDeleteConfirm(false)}
            >
              {t('userAccount.userInfoTab.deleteConfirm.cancel', {
                defaultValue: 'Atšaukti',
              })}
            </Button>
            <Button
              variant="secondary"
              loading={loading}
              onClick={handleUserAccountDeleteConfirm}
            >
              {t('userAccount.userInfoTab.deleteConfirm.continue', {
                defaultValue: 'Ištrinti',
              })}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </Card>
  );
}
